import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VConsole from "vconsole";
import './registerServiceWorker'

Vue.config.productionTip = false

import '@/assets/index.scss';

import { Icon } from 'vant';
import { Popup } from 'vant';
import { Loading } from 'vant';
Vue.use(Loading);
Vue.use(Popup);
Vue.use(Icon);
import RulePopup from '@/plugins/rule-popup';
Vue.use(RulePopup);

if (process.env.NODE_ENV !== 'production') {
  const vConsole = new VConsole();
  console.log(vConsole.version);
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
